export class FeatureToggleLevel{
    static global:string = "Global";
    static fund:string = "Fund";
    static accountClassification:string = "Account Classification";
    static accountType:string = "Account Type";
}